import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './components/ui/Toast';
import { msalConfig } from './config/authConfig';
import './index.css';

// MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Render app function
const renderApp = () => {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <AuthProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </AuthProvider>
        </MsalProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
};

// Initialize MSAL with error handling and timeout
let rendered = false;

const safeRender = () => {
  if (!rendered) {
    rendered = true;
    renderApp();
  }
};

// Timeout fallback - render after 10 seconds if MSAL hasn't initialized
const timeoutId = setTimeout(() => {
  console.warn('MSAL initialization timeout - rendering anyway');
  safeRender();
}, 10000);

msalInstance.initialize()
  .then(() => {
    console.log('MSAL initialized successfully');
    // Handle redirect promise - CRITICAL for processing login redirect response
    return msalInstance.handleRedirectPromise();
  })
  .then((response) => {
    clearTimeout(timeoutId);
    if (response) {
      console.log('Login redirect handled successfully', response.account?.username);
    }
    safeRender();
  })
  .catch((error) => {
    clearTimeout(timeoutId);
    console.error('MSAL initialization or redirect handling failed:', error);
    safeRender();
  });
